import React, { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSearch,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import CycleTimeTrend from "./sprintcentraltransformation/CycleTimeTrend";
import WIPTrend from "./sprintcentraltransformation/WIPTrend";
import BlockedWorkChart from "./sprintcentraltransformation/BlockedWorkChart";
import RequirementChangeRate from "./sprintcentraltransformation/RequirementChangeRate";
import SprintPredictability from "./sprintcentraltransformation/SprintPredictability";
import AISprintRisk from "./sprintcentraltransformation/AISprintRisk";

const SprintCentralTransformation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const [reports, setReports] = useState([]);
  const [search, setSearch] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 8;

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  // -----------------------
  // Sample Reports Data
  // -----------------------

  const sampleReports = [
    {
      id: 1,
      title: "Sprint Performance",
      metric1: "Avg Velocity: 30",
      metric2: "Completion Rate: 92%",
      metric3: "Delayed Sprints: 1",
    },
    {
      id: 2,
      title: "Task Progress",
      metric1: "Total Tasks: 84",
      metric2: "Completed: 52",
      metric3: "Pending: 14",
    },
    {
      id: 3,
      title: "Issue Tracking",
      metric1: "Open Issues: 7",
      metric2: "Resolved: 23",
      metric3: "Critical: 2",
    },
    {
      id: 4,
      title: "Team Productivity",
      metric1: "Members: 6",
      metric2: "Tasks / Member: 8",
      metric3: "Cycle Time: 2.3 days",
    },
    {
      id: 5,
      title: "Cost Overview",
      metric1: "Budget: ₹12,00,000",
      metric2: "Actual: ₹10,75,000",
      metric3: "Variance: -₹1,25,000",
    },
    {
      id: 6,
      title: "Meeting Analytics",
      metric1: "Standups: 18",
      metric2: "Sprint Reviews: 6",
      metric3: "Retrospectives: 4",
    },
  ];

  const loadSample = () => {
    setReports(sampleReports);
  };

  const stats = {
    activeSprint: "Sprint 12",
    velocity: 32,
    completion: 91,
    issues: 7
  };

  const burndownData = [
    { day: "Day1", remaining: 120 },
    { day: "Day2", remaining: 100 },
    { day: "Day3", remaining: 80 },
    { day: "Day4", remaining: 60 },
    { day: "Day5", remaining: 40 }
  ];

  const velocityData = [
    { sprint: "S8", velocity: 24 },
    { sprint: "S9", velocity: 31 },
    { sprint: "S10", velocity: 28 },
    { sprint: "S11", velocity: 35 }
  ];

  const issueSeverity = [2, 5, 10, 8];

  const rootCauseData = [
    { cause: "Requirement Change", count: 8 },
    { cause: "Testing Delay", count: 5 },
    { cause: "Dependency Issue", count: 4 },
    { cause: "Infrastructure", count: 3 }
  ];

  const healthMetrics = {
    sprintCompletion: 90,
    velocityStability: 80,
    bugSeverity: 75,
    cycleTime: 85,
    teamLoad: 70
  };

  // -----------------------
  // SEARCH
  // -----------------------

  const filtered = reports.filter((r) =>
    r.title.toLowerCase().includes(search.toLowerCase()),
  );

  const totalPages = Math.ceil(filtered.length / perPage);

  const paginated = filtered.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage,
  );

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 p-2">
      {/* HEADER */}

      <header className="sticky top-0 z-50 bg-black border-b border-blue-500/40 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-cyan-300">
            🧠 SprintCentral Transformation Intelligence 
          </div>

          <div className="text-xs text-gray-400">
            AI Powered Agile Project Transformation Intelligence
          </div>
        </div>

        <div className="hidden md:flex items-center gap-4">
          {isLoggedIn ? (
            <>
              <span className="text-xs text-teal-300">{userName}</span>

              <button
                onClick={handleLogout}
                className="w-12 px-2 py-1 bg-red-700/80 hover:bg-red-600 rounded-md text-sm"
              >
                ⏻
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="w-12 px-2 py-1 border border-teal-600 rounded-md"
            >
              🔐
            </button>
          )}
        </div>
      </header>
      <div className="mt-2 mb-2 min-h-[70vh]">
        {/* <FiltersBar/>

        <KPIWidgets stats={stats}/> */}

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 mt-2">
          <CycleTimeTrend />

          <WIPTrend />

          <BlockedWorkChart />

          <RequirementChangeRate />

          <SprintPredictability />
          
          {/* <div className="w-80 h-80">
            <BurndownChart data={burndownData}/>
          </div>
          <div className="w-80 h-80">
            <VelocityChart data={velocityData}/>
          </div>
          <div className="w-80 h-full">
            <IssueSeverityChart data={issueSeverity}/>
          </div> */}
            {/* <ProjectHealthScore metrics={healthMetrics}/> */}
          {/* <div className="w-80 h-full">
            <RootCausePieChart data={rootCauseData}/>
          </div>
          <div className="w-80 h-80">
            <RootCauseTable data={rootCauseData}/>
          </div>   */}
        </div>
      </div>

      <footer className="bg-black border-t border-blue-400 text-white py-4 mt-10">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">
            © 2026 Think5Whys Global DeepTech Solutions.
          </div>

          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">
              About
            </Link>

            <Link to="/privacy-policy" className="hover:text-teal-300">
              Privacy Policy
            </Link>

            <Link to="/terms-of-use" className="hover:text-teal-300">
              Terms
            </Link>

            <Link to="/contact-us" className="hover:text-teal-300">
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SprintCentralTransformation;
